import { OrganizationBreadcrumbs } from "@knowfully/ui.common";
import { SxProps, Theme, Typography, useTheme } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  OrganizationTreeItem,
  ResponseOfOrganizationTreeItem,
} from "services/organizationPortalClient";
import authStore from "stores/authStore";
import contextStore from "stores/contextStore";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  breadcrumb: {
    textTransform: "none",
    textAlign: "left",
    fontSize: "1rem",
    color: theme.palette.primary.dark,
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
    },
    "&.MuiButtonBase-root": {
      border: 0,
      backgroundColor: "initial",
    },
  },
  expandIcon: {
    height: "fit-content",
    fontSize: "1rem",
    color: theme.palette.primary.dark,
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
    },
  },
});

const OrganizationBreadcrumbsWrapper = () => {
  const styles = getStyles(useTheme());
  const { organizationService } = useGlobalContext();
  const userId = authStore.useState((s) => s.id);
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();

  const onChangeOrganization = (organization: OrganizationTreeItem) =>
    contextStore.update((s) => {
      s.organization = {
        id: organization?.id,
        name: organization?.name,
        displayName: organization?.displayName,
        organizationTypeId: organization?.organizationTypeId,
      };
    });

  const {
    isLoading,
    isError,
    data: organizationTreeResponse,
  } = useQuery<ResponseOfOrganizationTreeItem>(
    "organization-tree",
    () => organizationService.getOrganizationTree(userId!),
    { enabled: !!userId },
  );

  useEffect(() => {
    if (!isLoading && organizationTreeResponse?.data) {
      if (!organization?.id) {
        onChangeOrganization(organizationTreeResponse.data);
      }
    }
  }, [isLoading, organizationTreeResponse, organization?.id]);

  if (isError || organizationTreeResponse?.responseReason != null) {
    return (
      <Typography color="error">
        {t({ id: "organizationBreadcrumbsFetchFailed" })}
      </Typography>
    );
  }

  return (
    <OrganizationBreadcrumbs
      organizationTree={organizationTreeResponse?.data!}
      selectedOrganizationId={organization?.id}
      onChange={onChangeOrganization}
      label={t({ id: "organizationAdmin" })}
      disabled={false}
      nonClientOrgnanizationsDisabled={true}
      sxBreadcrumb={styles.breadcrumb}
      sxExpandIcon={styles.expandIcon}
    />
  );
};

export default OrganizationBreadcrumbsWrapper;
